module.exports = __webpack_public_path__ + "img/flow4.f4392c93.png";